import { Inject, Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
  providedIn: 'root'
})
export class MultiFactorService {
    constructor(private cvApiService: CVApiService) { }

    public async getMultiFactorState(loginId?: number): Promise<MultiFactorState> {
        let route = "/api/v1/multi-factor-state";
        if (loginId !== undefined) {
            route += `?loginId=${encodeURIComponent(loginId)}`;
        }

        try {
            let response = await this.cvApiService.get<MultiFactorState>(route);
            if (response.status_code != 200)
                throw response;
            return response.data;
        } catch (err) {
            console.error("Error getting Multi-factor state:", err);
            throw err;
        }
    }

    public async postEnableMultiFactor(): Promise<MultiFactorState> {
        try {
            let response = await this.cvApiService.post<MultiFactorState>("/api/v1/enable-multi-factor");
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            throw response;
        } catch (err) {
            console.error("Failed to enable Multi-Factor:", err);
            throw err;
        }
    }

    public async postDisableMultiFactor(): Promise<MultiFactorState> {
        try {
            let response = await this.cvApiService.post<MultiFactorState>("/api/v1/disable-multi-factor");
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            throw response;
        } catch (err) {
            console.error("Failed to disable Multi-Factor for login:", err);
        }
    }

    public async postResetAuthenticator(loginId?: number): Promise<MultiFactorState> {
        let loginParameter = "";
        if (typeof loginId === "number")
            loginParameter = "?loginId=" + loginId;

        try {
            let response = await this.cvApiService.post<MultiFactorState>(`/api/v1/reset-authenticator${loginParameter}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            throw response;
        } catch (err) {
            console.error("Failed to reset authenticator:", err);
        }
    }
}

// ClearView WebPortal/AppCode/Api/Controllers/MultiFactorController.cs
export interface MultiFactorState {
    LoginId: number;
    Algorithm: Algorithm;
    Active: boolean;
    Required: boolean;
    SendEmail: boolean;
    LastChanged: string | Date;
    QrCodeActive: boolean;
}

export const enum Algorithm {
    TOTP_SHA1 = 0,
}
